import * as React from 'react';
import InputMask from 'react-input-mask';
import { useFormControlContext, useStyles, isDefined } from '@sravni/react-utils';
import { TextInput } from '../../TextInput/src/TextInput.js';
import modules_8f2c8bee from '../styles/MaskInput.module.less.js';

/**
 * @description The Mask Input component allows user to type in text with mask
 *
 * @component
 * @example
 * ```jsx
 * <MaskInput placeholder="Дата" mask="99/99/9999" value={value} onChange={handleChange} />
 * ```
 */
const MaskInput = React.forwardRef((props, ref) => {
    const { defaultValue, value, mask, placeholder, className, onChange, ...restProps } = props;
    const [innerValue, setInnerValue] = React.useState(value || defaultValue);
    const formControlContext = useFormControlContext();
    const cx = useStyles(modules_8f2c8bee);
    const classNames = cx(className, 'container');
    const inputProps = React.useMemo(() => ({
        ...formControlContext,
        ...restProps,
    }), [restProps, formControlContext]);
    const handleChange = (event) => {
        setInnerValue(event.currentTarget.value);
        onChange?.(event.currentTarget.value);
    };
    React.useEffect(() => {
        isDefined(value) && setInnerValue(value);
    }, [value]);
    return (React.createElement("div", { "data-qa": "MaskInput", className: classNames },
        React.createElement(InputMask, { mask: mask, value: innerValue, onChange: handleChange, ...inputProps },
            React.createElement(TextInput, { ref: ref, placeholder: placeholder }))));
});
MaskInput.defaultProps = {};
MaskInput.displayName = 'MaskInput';

export { MaskInput };
//# sourceMappingURL=MaskInput.js.map
